export default "__VITE_ASSET__BNUCbxpk__"